import React from 'react';
import { useTranslation } from 'react-i18next';

import { QBox, QStack, QText } from '@captivateiq/quotient';

import assistantI18n from '@captivateiq/assistant/i18n';

import { AgentBanner } from '@captivateiq/assistant/assets';
import { getAgentConfig } from '@captivateiq/assistant/config/agentConfig';

type AgentIntroductionProps = {
  agentName: string;
};

export const AgentIntroduction = ({ agentName }: AgentIntroductionProps) => {
  const { t } = useTranslation('assistant', { i18n: assistantI18n });
  const config = getAgentConfig(agentName, t);

  return (
    <QStack direction="column" spacing="10px">
      <QBox
        sx={{
          width: '100%',
          overflow: 'hidden',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AgentBanner agentKitName={agentName} width="100%" />
      </QBox>
      <QStack
        direction="column"
        spacing="10px"
        sx={{
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <QText
          sx={{
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '22px',
            color: 'text.onSurface.background.highContrast',
          }}
        >
          {config.name}
        </QText>
        <QText
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
            color: 'text.onSurface.background.mediumContrast',
            maxHeight: '40px',
            textOverflow: 'ellipsis',
          }}
        >
          {config.medium_description}
        </QText>
      </QStack>
    </QStack>
  );
};
